import styled from 'styled-components';
export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(${_ref => {
  let {
    gridColumns
  } = _ref;
  return gridColumns;
}}, 1fr);
  grid-template-rows: masonry;
  column-gap: ${_ref2 => {
  let {
    columnGap
  } = _ref2;
  return columnGap;
}}px;
  row-gap: ${_ref3 => {
  let {
    rowGap
  } = _ref3;
  return rowGap;
}}px;
`;
export const Item = styled.div`
  grid-column: span ${_ref4 => {
  let {
    actualItemSize
  } = _ref4;
  return actualItemSize;
}};
`;